import { axios } from '@/utils/request'

function appendParams(url, key, value, isFirst) {
  return isFirst ? (url + '?' + key + '=' + value) : (url + '&' + key + '=' + value)
}

function getTargetUrl(baseUrl, params) {
  let hasStartFlag = baseUrl.indexOf('?') !== -1
  if (params instanceof Object) {
    let requestUtl = baseUrl
    for (let key in params) {
      if (params[key] !== undefined) {
        if (!hasStartFlag) {
          hasStartFlag = true
          requestUtl = appendParams(requestUtl, key, params[key], true)
        } else {
          requestUtl = appendParams(requestUtl, key, params[key], false)
        }
      }
    }
    return requestUtl
  } else {
    return baseUrl
  }
}

/**
 * @param baseURL   基本地址
 * @param url     请求地址
 * @param method 请求方法类型
 * @param params 请求参数
 * @param headers  请求头
 * @returns {AxiosPromise}
 */
function getRequest(baseURL, url, method, params, headers) {
  return axios({
    baseURL: baseURL,
    url: url,
    method: method,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      ...headers
    }
  })
}

/**
 * 发起通用请求
 * @param baseURL 基本地址
 * @param url 地址
 * @param method 请求方式
 * @param params  简化后的参数
 * @param headers  请求头
 * @returns {Promise<unknown>}
 */
function getCommonRequest(baseURL, url, method, params, headers) {
  return new Promise((resolve, reject) => {
    getRequest(baseURL, url, method, params, headers)
      .then(res => {
        if (res.status == 1) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch(reason => {
        reject(reason)
      })
  })
}

export default class BaseService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  request(path, method, params, headers) {
    return getCommonRequest(this.baseUrl, path, method, params, headers)
  }

  post(path, params, headers) {
    return this.request(path, 'POST', params, headers)
  }

  get(path, params, headers) {
    const requestPath = getTargetUrl(path, params)//get请求得手动拼接参数
    return this.request(requestPath, 'GET', {}, headers)
  }

  put(path, params, headers) {
    return this.request(path, 'PUT', params, headers)
  }

  delete(path, params, headers) {
    return this.request(path, 'DELETE', params, headers)
  }

  static getTargetUrl(baseUrl, params) {
    return getTargetUrl(baseUrl, params)
  }
}